import { ComputedFees } from "../../../types/CompanyPensionProduct";
import DynamicText from "../DynamicText";
import { FormattedValue, SimpleTable, Tooltip } from "frno-react";
import useTextStore from "../../../state/TextStore";
import useIsMobile from "../../../hooks/useIsMobile";

type FeeDetailsTableProps = {
  headerKey: string;
  computedFees: ComputedFees;
  savingsValue: number;
};
export default function FeeDetailsTable({
  headerKey,
  computedFees,
  savingsValue,
}: FeeDetailsTableProps) {
  const boldHeaders = new Set([
    "page.companies.table.expandedrow.feedetails.header",
  ]);

  const { getTextByKey } = useTextStore();
  const { isMobile } = useIsMobile();
  const isBold = boldHeaders.has(headerKey);

  function createTableData(computedFees: ComputedFees) {
    const tableData = [
      {
        label: !isMobile
          ? "page.companies.table.expandedrow.feedetails.managementfee"
          : "page.companies.table.expandedrow.feedetails.mobile.managementfee",
        tooltipContent: {
          title: "page.companies.table.expandedrow.feedetails.managementfee",
          content:
            "page.companies.table.expandedrow.feedetails.tooltip.managementfee",
        },

        dataColumns: [
          { value: computedFees.managementFee.amount, postfix: "kr" },
          { value: computedFees.managementFee.percent, postfix: "%" },
        ],
      },
      {
        label: "page.companies.table.expandedrow.feedetails.platformfee",
        tooltipContent: {
          title: "page.companies.table.expandedrow.feedetails.platformfee",
          content:
            "page.companies.table.expandedrow.feedetails.tooltip.platformfee",
        },
        dataColumns: [
          { value: computedFees.platformFee.amount, postfix: "kr" },
          { value: computedFees.platformFee.percent, postfix: "%" },
        ],
      },
      {
        label: !isMobile
          ? "page.companies.table.expandedrow.feedetails.annualfee"
          : "page.companies.table.expandedrow.feedetails.mobile.annualfee",
        tooltipContent: {
          title: "page.companies.table.expandedrow.feedetails.annualfee",
          content:
            "page.companies.table.expandedrow.feedetails.tooltip.annualfee",
        },
        dataColumns: [
          { value: computedFees.annualAdministrationFee.amount, postfix: "kr" },
          { value: computedFees.annualAdministrationFee.percent, postfix: "%" },
        ],
      },
      {
        label: "page.companies.table.expandedrow.feedetails.totalfee",
        dataColumns: [
          { value: computedFees.totalFee.amount, postfix: "kr" },
          { value: computedFees.totalFee.percent, postfix: "%" },
        ],
      },
    ];

    return Object.values(tableData).map((row, index) => {
      return {
        columns: [
          {
            content: (
              <DynamicText key={`row-${index}-col-0`} textKey={row.label} />
            ),
            tooltip: row.tooltipContent ? (
              <Tooltip
                title={getTextByKey(row.tooltipContent.title)}
                content={<DynamicText textKey={row.tooltipContent.content} />}
              />
            ) : undefined,
          },
          ...row.dataColumns.map((col, colIndex) => ({
            content: (
              <span className="tnum" key={`row-${index}-col-${colIndex}`}>
                <FormattedValue value={col.value} postfix={col.postfix} />
              </span>
            ),
          })),
        ],
        className: tableData.length - 1 === index ? "fw-500 mt-4" : "",
      };
    });
  }

  return (
    <SimpleTable
      header={
        <DynamicText
          className={isBold ? "bold-header" : ""}
          textKey={headerKey}
          replaceComponent={
            <span className="tnum">
              <FormattedValue value={savingsValue} postfix="kr" />
            </span>
          }
        />
      }
      rows={createTableData(computedFees)}
    />
  );
}
